import _ from './icon-button.module.scss'
import React, {useEffect, useRef, useState} from 'react'
import {$$$, $} from '../shared/class-name'
import {Fade} from './fade'

export const IconButton = ({
    children, counter, onClick, title, disabled, blocked, color, size, active, draggable, onDragStart, onDragEnd, className,
    style, counterClassName, noBackground, autoWidth, counterRight, counterBottom, smallCounter, noPointerEvents, badge=false,
    activeBadge=false, inert, noTab, dropShadow, thinBorder, hovered, inline, visible = true, thickBorder, ariaLabel, pressed
}) => {
    const [shaking, setShaking] = useState(false)
    const shakeFrameRef = useRef(null)
    useEffect(() => () => {
        if (shakeFrameRef.current != null) cancelAnimationFrame(shakeFrameRef.current)
    }, [])
    const shakeDisabled = e => {
        if (!disabled && !blocked) return
        e.stopPropagation()
        if (shakeFrameRef.current != null) cancelAnimationFrame(shakeFrameRef.current)
        setShaking(false)
        shakeFrameRef.current = requestAnimationFrame(() => {
            shakeFrameRef.current = requestAnimationFrame(() => {
                shakeFrameRef.current = null
                setShaking(true)
            })
        })
    }
    const handleClick = e => {
        e.stopPropagation()
        if (blocked) return shakeDisabled(e)
        if (disabled) return
        onClick?.(e)
    }

    const buttonTemplate = <>
        <Fade
            as="button"
            visible={visible}
            className={$$$(
                $(_.button),
                $(_[color], color),
                $(_[size], size),
                $(_.active, active),
                $(_.hovered, hovered),
                $(_.noBackground, noBackground),
                $(_.autoWidth, autoWidth),
                $(className),
                $(_.noPointerEvents, noPointerEvents),
                $(_.dropShadow, dropShadow),
                $(_.badge, badge || activeBadge),
                $(_.clickableBadge, badge && onClick),
                $(_.activeBadge, activeBadge),
                $(_.disabledShake, shaking),
                $(_.thinBorder, thinBorder),
                $(_.thickBorder, thickBorder),
            )}
            style={style}
            onPointerDown={disabled ? shakeDisabled : undefined}
            onClick={handleClick}
            title={title}
            aria-label={ariaLabel}
            aria-pressed={pressed}
            disabled={disabled}
            aria-disabled={blocked || undefined}
            draggable={draggable}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            onAnimationEnd={() => setShaking(false)}
            inert={inert ? '' : undefined}
            tabIndex={badge || noTab ? -1 : undefined}
        >{children}</Fade>
        {counter != null && <Fade as="span" visible={visible} className={$$$(
            _.counter, $(_.counterRight, counterRight), $(_.counterBottom, counterBottom), $(counterClassName),
            $(_.smallCounter, smallCounter)
        )}>{counter}</Fade>}
    </>

   return inline ? <span className={_.inline}>{buttonTemplate}</span> : buttonTemplate
}
